import { render } from "./ScriptureContent.vue?vue&type=template&id=cb204994&scoped=true"
import script from "./ScriptureContent.vue?vue&type=script&lang=ts"
export * from "./ScriptureContent.vue?vue&type=script&lang=ts"

import "./ScriptureContent.vue?vue&type=style&index=0&id=cb204994&scoped=true&lang=css"
import "../../components/Video/VideoStyling.css?vue&type=style&index=1&lang=css"
script.render = render
script.__scopeId = "data-v-cb204994"

export default script